/**
 * this fonction is deprecated it has been renamed to parseActualContentConstraints instead
 *
 * @memberOf SDMXJS
 * @name getActualContentConstraints
 * @type function
 * @api public
 * @tag structure
 * @tag parsing
 * @deprecated since v5.5.4
 **/

import { parseActualContentConstraints } from './';
export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (structure) {
    // eslint-disable-next-line no-console
    console.warn('[deprecation warning]: getActualContentConstraints has been renamed to parseActualContentConstraints');
    parseActualContentConstraints(options)(structure);
  };
});